import { createRoutine } from 'redux-saga-routines'

export const SET = 'STATIC_CONTENT/SET'
export const CONTENT = createRoutine('STATIC_CONTENT/CONTENT')
